import {_, React, classNames, withStyles, StyledProps, CentricTheme, styled} from '@api'
import { TextField, FormControl, FormHelperText, PropTypes } from '@material-ui/core'
import { FormHelperTextProps } from '@material-ui/core/FormHelperText';
import { InputProps } from '@material-ui/core/Input'
import { InputLabelProps } from '@material-ui/core/InputLabel'
import { SelectProps } from '@material-ui/core/Select';
import {StandardTextFieldProps, TextFieldProps} from '@material-ui/core/TextField';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as css from './TextInput.css'

interface MyProps { //, Partial<TextFieldProps> {  // Can't do this as classes will conflict
  className?: string
  /** String for the name of the field */
  name?: string,
  /** String for the field's label */
  label?: string,
  /** Change handler */
  onChange?: (e) => void
  /** Click handler */
  onClick?: any
  /** Boolean indicating whether the field is errored or not */
  error?: boolean
  /** String for field's error text when errored */
  errorText?: string
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean

  onBlur?: (e) => void;
  autoComplete?: string;
  autoFocus?: boolean;
  children?: React.ReactNode;
  defaultValue?: string | number;
  FormHelperTextProps?: Partial<FormHelperTextProps>;
  fullWidth?: boolean;
  helperText?: React.ReactNode;
  id?: string;
  InputLabelProps?: Partial<InputLabelProps>;
  InputProps?: Partial<InputProps>;
  inputProps?: InputProps['inputProps'];
  inputRef?: React.Ref<any> | React.RefObject<any>;
  margin?: PropTypes.Margin;
  multiline?: boolean;
  placeholder?: string;
  required?: boolean;
  rows?: string | number;
  rowsMax?: string | number;
  select?: boolean;
  SelectProps?: Partial<SelectProps>;
  type?: string;
  /** Value of the field */
  value?: any
  loading?: boolean
  variant?: any
}

@observer
export class TextInput extends React.Component<MyProps> {
  static defaultProps = {
    name:      '',
    label:     '',
    value:     '',
    onChange:  () => {},
    onClick: () => {},
    error:     false,
    errorText: '',
    disabled:  false
  }

  render() {
    const {name, label, value, onChange, onClick, error, errorText, disabled, className, loading, ...otherProps} = this.props, {onBlur, onFocus, focused} = this

    return (
      <FormControl className={css.root} classes={{root: css.formText}} error={error} aria-describedby={`${name}-error-text`}>
        <TextField
          data-focused={focused}
          data-multiline={otherProps.multiline === true}
          className={classNames(css.text, className)}
          InputProps={{
            classes: {
              input:    classNames({skeleton: loading}),
              disabled:  css.disabled,
              underline: css.underline,
              error:     css.error,
              focused:   css.focused
            }
          }}
          InputLabelProps={{
            classes:          {
              formControl: classNames({skeleton: loading}, css.inputLabel),
              shrink: css.shrink,
              focused: css.inputLabelFocused},
          }}
          error={error}
          label={label}
          value={value || ''}
          onChange={onChange}
          onClick={onClick}
          name={name}
          disabled={disabled}
          {...otherProps}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        {error && !disabled ? <FormHelperText classes={{root: css.helperText}} id={`${name}-error-text`}>{errorText}</FormHelperText> : null}
      </FormControl>
    )
  }

  @observable focused = false
  @action onFocus = () => {
    this.focused = true
    const {props: {}} = this
  }

  @action onBlur = (e) => {
    this.focused = false
    const {props: {onBlur}} = this
    onBlur && onBlur(e)
  }
}




// WEBPACK FOOTER //
// ./src/shared/components/ui/components/TextInput.tsx